export const productOrBrandSpotlightJson = {
  page: {
    body: {
      container: { style: { 'background-color': '#FFFFFF' } },
      content: {
        computedStyle: { linkColor: '#0075e0', messageBackgroundColor: 'transparent', messageWidth: '700px' },
        style: { color: '#000000', 'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif" },
      },
      type: 'mailup-bee-page-properties',
      webFonts: [],
    },
    description: 'empty-dutchie-template',
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            mobileStyle: {
              'padding-bottom': '40px',
              'padding-left': '24px',
              'padding-right': '24px',
              'padding-top': '40px',
            },
            modules: [
              {
                descriptor: {
                  computedStyle: { class: 'center fixedwidth', hideContentOnMobile: false, width: '124px' },
                  image: {
                    alt: '',
                    height: '140px',
                    href: '',
                    percWidth: 20,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/yub/3ji/j88/Dispo%20Logos.png',
                    target: '_blank',
                    width: '252px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '40px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '0fda11bb-f0f8-4142-9c5b-65a45dcc60ca',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#c1d3f1',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '14px',
                      'font-weight': '700',
                      'letter-spacing': '1px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">NEW PRODUCT PROMOTION</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '12px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '670db7db-ad4f-440d-ab49-3ee815883d31',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#fff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '48px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Get it before it’s gone!</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '32px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: 'd8251649-166d-422c-bcd5-5bc0ad5b9a74',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  mobileStyle: {
                    'font-size': '14px',
                    'padding-bottom': '32px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>',
                    style: {
                      color: '#fff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '48px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '1ba0aa0f-3a5e-40b7-b335-f0bb6480d9ba',
              },
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '620px',
                  },
                  image: {
                    alt: '',
                    height: '721px',
                    href: '',
                    percWidth: 100,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/k1g/8r1/1pn/Product_Photo.jpg',
                    target: '_blank',
                    width: '1200px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '57c3df20-a7be-47c1-9014-73301215a282',
              },
              {
                descriptor: {
                  button: {
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">Shop Now</p></div>',
                    percWidth: 51,
                    style: {
                      'background-color': '#0075e0',
                      'border-bottom': '0px solid transparent',
                      'border-left': '0px solid transparent',
                      'border-radius': '4px',
                      'border-right': '0px solid transparent',
                      'border-top': '0px solid transparent',
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '12px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '12px',
                      width: '60%',
                    },
                    target: '_blank',
                  },
                  computedStyle: { height: 56, hideContentOnMobile: false, width: 314 },
                  mobileStyle: {
                    'font-size': '14px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '32px',
                  },
                  style: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                    'text-align': 'center',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: 'bcc186fb-d752-4988-9248-66da9250a14a',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '40px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '60px',
            },
            uuid: 'cb911f58-1e3e-4d35-9717-73e278881987',
          },
        ],
        container: {
          style: {
            'background-color': '#10304d',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#333',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '4bf4a6fc-45d2-41ae-a96c-1604a93d8e16',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            mobileStyle: {
              'padding-bottom': '48px',
              'padding-left': '24px',
              'padding-right': '24px',
              'padding-top': '48px',
            },
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Questions? Please refer to our FAQs or emailus at <u>hello@northcannabisco.com</u>.<br/>Copyright © 2024 Dutchie, Inc - All Rights Reserved.<br/>2728 North West Potts Court, Bend OR, 97701</p>',
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '12px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '180%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: 'a8b214b6-f53c-45e6-bd48-51808953f9dd',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '48px',
              'padding-left': '48px',
              'padding-right': '48px',
              'padding-top': '48px',
            },
            uuid: '198060dd-79f0-4224-b34d-553e7e703b1a',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: 'c7c3a967-d5b9-4369-9ed0-5faaeedd4c89',
      },
    ],
    template: { name: 'template-base', type: 'basic', version: '2.0.0' },
    title: 'empty-dutchie-template',
  },
  comments: {},
};
